import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {SortUserFavoritesService} from './SortUserFavoritesService'

/**
 * @implements Service
 */
export default class GetUserFavoritesService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.config
   * @param {Object} deps.getCurrentUserService
   * @param {Object} deps.getUserNotLoggedInUserError
   */
  constructor({config, repository, getCurrentUserService, getUserNotLoggedInUserError}) {
    super({
      config,
      repository,
      getCurrentUserService,
      getUserNotLoggedInUserError
    })

    this._config = config
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._getUserNotLoggedInUserError = getUserNotLoggedInUserError
  }

  _getUserId = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    if (!currentUser) {
      throw this._getUserNotLoggedInUserError({message: '[GetUserFavoritesService#execute] Unknown user ID'}).toJSON()
    }
    return currentUser.getId()
  }

  /**
   * @param {Object} params
   * @param {Object} params.search - Optional search/sort parameters
   * @return {Promise<Object, Error>} returns current logged user favorites
   * @property {Object} user
   */
  @inlineError
  async execute({search} = {}) {
    const userId = await this._getUserId()

    const favorites = await this._repository.get({userId})

    if (!search) {
      return favorites.toJSON()
    }

    const sortUserFavoritesService = SortUserFavoritesService.create({
      config: this._config,
      items: favorites.toJSON(),
      search
    })

    const [sortedFavoritesError, sortedFavorites] = await sortUserFavoritesService.execute()

    if (sortedFavoritesError) return Promise.reject(sortedFavoritesError)

    // Todo: map to VO (https://jira.ets.mpi-internal.com/browse/MTR-104401)
    return sortedFavorites
  }
}
